import axios from 'axios'

export default {
  getUserById ({ commit }, { id }) {
    commit('getUserByIdRequest')
    let url = `/api/user/${id}/`
    return axios
      .get(url)
      .then(function (response) {
        commit('getUserByIdSuccess', response.data)
        return response.data
      })
      .catch(function (error) {
        commit('getUserByIdFailure', error)
        throw error
      })
  },
  updateUser ({ commit }, user) {
    commit('updateUserRequest')
    let url = `/api/user/${user.id}/`
    return axios
      .put(url, user)
      .then(function (response) {
        commit('updateUserSuccess', response.data)
        return response.data
      })
      .catch(function (error) {
        commit('updateUserFailure', error.response.data)
        throw error.response.data
      })
  },
  login ({ commit }, { username, password }) {
    commit('loginRequest')
    return axios
      .post('/api/login/', { username, password })
      .then((response) => {
        commit('loginSuccess', response.data)
        return response
      })
      .catch((error) => {
        commit('loginFailure', error)
        throw error
      })
  },
  logout ({ commit }) {
    commit('logoutRequest')
    return axios
      .post('/api/logout/')
      .then((response) => {
        commit('logoutSuccess', response)
        return response
      })
      .catch((error) => {
        commit('logoutFailure', error)
        throw error
      })
  },
  changePassword ({ commit }, { old_password, new_password, confirm_password }) {
    commit('changePasswordRequest')
    return axios
      .patch('/api/change-password/', { old_password, new_password, confirm_password })
      .then((response) => {
        commit('changePasswordSuccess', response.data)
        return response
      })
      .catch((error) => {
        commit('changePasswordFailure', error)
        throw error
      })
  },
  forgotPassword({ commit }, { email }) {
    commit("forgotPasswordRequest");
    let payload = JSON.stringify({ email });
    return axios
      .post("/api/forgot-password/", payload)
      .then(function (response) {
        commit("forgotPasswordSuccess", response.data);
        return response;
      })
      .catch(function (error) {
        commit("forgotPasswordFailure", error);
        throw error;
      });
  },
  passwordResetConfirm({ commit }, password) {
    commit('passwordResetConfirmRequest');
    return axios
      .post('/api/reset-password/', password)
      .then((response) => {
        commit('passwordResetConfirmSuccess', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('passwordResetConfirmFailure', error.response.data);
        throw error.response.data;
      });
  },
  sendBulkMessage ({ commit }, { selectedGradeLevels, message }) {
    commit('sendBulkMessageRequest')
    return axios
      .post('/api/send-message/', { selectedGradeLevels, message })
      .then((response) => {
        commit('sendBulkMessageSuccess', response.data)
        return response
      })
      .catch((error) => {
        commit('sendBulkMessageFailure', error)
        throw error
      })
  },

  testSendBulkMessage ({ commit }, { number, message }) {
    commit('testSendBulkMessageRequest')
    return axios
      .post('/api/test-send-message/', { number, message })
      .then((response) => {
        commit('testSendBulkMessageSuccess', response.data)
        return response
      })
      .catch((error) => {
        commit('testSendBulkMessageFailure', error)
        throw error
      })
  },
  getRecipients ({ commit }, params) {
    commit('getRecipientsRequest')
    return axios
      .get('/api/get-recipient/', { params })
      .then(function (response) {
        commit('getRecipientsSuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('getRecipientsFailure', error)
        throw error
      })
  },
  getItexMoStatus ({ commit }) {
    commit('getItexMoStatusRequest')
    return axios
      .get('/api/get-messages/')
      .then(function (response) {
        commit('getItexMoStatusSuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('getItexMoStatusFailure', error)
        throw error
      })
  },
  getOutgoingMessages ({ commit }) {
    commit('getOutgoingMessagesRequest')
    return axios
      .get('/api/get-outgoing-messages/')
      .then(function (response) {
        commit('getOutgoingMessagesSuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('getOutgoingMessagesFailure', error)
        throw error
      })
  },
  getSMSHistory ({ commit}, params) {
    commit('getSMSHistoryRequest')
    return axios
      .get('/api/get-history/', { params })
      .then(function (response) {
        commit('getSMSHistorySuccess', response.data)
        return response.data
      })
      .catch((error) => {
        commit('getSMSHistoryFailure', error)
        throw error
      })
  },

}
